'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ImageSliderController = function () {
  function ImageSliderController($scope, $element) {
    _classCallCheck(this, ImageSliderController);

    this.svc = {
      $scope: $scope,
      element: $element[0]
    };
    this.hover = false;
    this.index = this.index || 0;

    this.activate();
  }

  _createClass(ImageSliderController, [{
    key: 'activate',
    value: function activate() {
      var _this = this;

      this.svc.$scope.$watch('$ctrl.images', function (newVal) {
        // Reset index to 0 when a new image collection is set.
        _this.index = 0;
      });
    }
  }, {
    key: 'isMouseOut',
    value: function isMouseOut(x, y, element) {
      var rect = this.svc.element.getBoundingClientRect();
      if (x <= rect.left || x >= rect.right || y <= rect.top || y >= rect.bottom) {
        return true;
      }
      return false;
    }
  }, {
    key: 'mouseEnter',
    value: function mouseEnter($event) {
      this.hover = true;
    }
  }, {
    key: 'mouseLeave',
    value: function mouseLeave($event) {
      if (!this.isMouseOut($event.clientX, $event.clientY, this.svc.element)) {
        return;
      }
      this.hover = false;
    }
  }, {
    key: 'setIndex',
    value: function setIndex(i) {
      this.index = i;
    }
  }, {
    key: 'slideLeft',
    value: function slideLeft() {
      this.index = this.index ? this.index - 1 : this.images.length - 1;
    }
  }, {
    key: 'slideRight',
    value: function slideRight() {
      this.index = this.index < this.images.length - 1 ? this.index + 1 : 0;
    }
  }]);

  return ImageSliderController;
}();

exports.default = ImageSliderController;


//////////////////
// WEBPACK FOOTER
// ./product-list/image-slider/index.js
// module id = 495
// module chunks = 0